<template>
    <validation-observer ref="fields">
        <v-row class="pb-2 mx-0 pt-3">

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <validation-provider name="Mansione" rules="required" v-slot="{ errors }">
                    <v-autocomplete class="font-weight-regular"
                        label="Mansione"
                        v-model="model['task_id']"
                        :error-messages="errors"
                        clearable
                        item-text="name"
                        item-value="id"
                        small-chips
                        :items="info.tasks"
                        dense
                        outlined>
                    </v-autocomplete>
                </validation-provider>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <validation-provider name="Minimo" rules="required|min:0" v-slot="{ errors }">
                    <v-text-field
                        label="Minimo"
                        type="number"
                        v-model="model['min']"
                        :error-messages="errors"
                        outlined
                        dense
                        ref="min"
                    ></v-text-field>
                </validation-provider>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <validation-provider name="Massimo" rules="required|min:0" v-slot="{ errors }">
                    <v-text-field
                        label="Massimo"
                        type="number"
                        v-model="model['max']"
                        :error-messages="errors"
                        outlined
                        dense
                        ref="max"
                    ></v-text-field>
                </validation-provider>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6">
                <v-checkbox
                    label="Richiesto"
                    v-model="model['required']"
                    color="primary"
                    :input-value="[true, false]"
                    ref="required"
                    hide-details
                ></v-checkbox>
				<div class="pt-2 pl-1 caption">Se selezionato il requisito deve essere soddisfatto</div>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6">
                <v-checkbox
                    label="Sufficiente"
                    v-model="model['sufficient']"
                    color="primary"
                    :input-value="[true, false]"
                    ref="sufficient"
                    hide-details
                ></v-checkbox>
				<div class="pt-2 pl-1 caption">Se il requisito e' soddisfatto il turno risulta coperto in ogni caso</div>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6">
                <v-checkbox
                    label="Nascosto"
                    v-model="model['hidden']"
                    color="primary"
                    :input-value="[true, false]"
                    ref="hidden"
                    hide-details
                ></v-checkbox>
				<div class="pt-2 pl-1 caption">Se il requisito risulta nascosto verra comunque verificato ma la persona non potra' segnarsi in quel ruolo</div>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6">
                <v-checkbox
                    label="Extra"
                    v-model="model['extra']"
                    color="primary"
                    :input-value="[true, false]"
                    ref="extra"
                    hide-details
                ></v-checkbox>
				<div class="pt-2 pl-1 caption">Il requisito viene verificato su tutte le capacita delle persone disponibili, indipendentemtne dal loro ruolo nel turno</div>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6">
                <v-checkbox
                    label="Ignora Gerarchia"
                    v-model="model['ignore_hierarchies']"
                    color="primary"
                    :input-value="[true, false]"
                    ref="ignore_hierarchies"
                    hide-details
                ></v-checkbox>
				<div class="pt-2 pl-1 caption">Durante la verfica vengono ignorate le gerarchie tra le mansioni</div>
            </v-col>


        </v-row>

    </validation-observer>    
</template>

<script>
export default {
	name: 'shifttypetask-fields',
	props: {
		create: {
			type: Boolean,
			default: false,
		},
		edit: {
			type: Boolean,
			default: false,
		},
		model: Object,
		info: Object,
	},
        
	data() {
		return {
			dialog: false,
			dialogType: null,
		}
	},
       

	computed: {

	},
        
	methods: {

		openDialog(type) {
			this.dialog = true
			this.dialogType = type
		}
	},

	created() {
	}
}
</script>

<style>

</style>